/* tslint:disable */
/* eslint-disable */
export * from './AdditionalContactDetails';
export * from './AdditionalContactDetailsRepresentativeBankDetails';
export * from './AdminApproveIdentityDocument';
export * from './AdminBankDetails';
export * from './AdminClientList';
export * from './AdminClientListCompletedOnboardingStepsInner';
export * from './AdminCreateSociety';
export * from './AdminIdentityDocumentSubmission';
export * from './AdminInterestRegistration';
export * from './AdminInterestRegistrationRepresentative';
export * from './AdminPersonalInformation';
export * from './AdminSociety';
export * from './AdminSocietyFormTask';
export * from './AdminSocietyFormTaskTasksInner';
export * from './AdminSocietyFormTaskUser';
export * from './AdminSocietySocietyFormsInner';
export * from './AdminTaskClient';
export * from './AdminTaskClientClientAdminTasksInner';
export * from './AdminTaskClientPrimaryDiscographyExportsInner';
export * from './AdminUpdateSociety';
export * from './AdminUpdateSocietyCredentials';
export * from './ArtistAlias';
export * from './ArtistAliasCreate';
export * from './ArtistAliasCreateSourceIds';
export * from './ArtistAliasCreateSourceIdsSpotifyInner';
export * from './ArtistAliasUpdate';
export * from './ArtistBand';
export * from './ArtistBandCreate';
export * from './ArtistBandUpdate';
export * from './ArtistDetails';
export * from './ArtistIdCollectionRunStatus';
export * from './ArtistSourceIdUpdate';
export * from './AutoCollectedIds';
export * from './AvailableFiltersResponse';
export * from './AvailableFiltersResponseAvailableFiltersInner';
export * from './BatchServiceResponse';
export * from './BatchServiceResponseResultsInner';
export * from './BulkEditRequest';
export * from './BulkEditRequestBulkEdit';
export * from './BulkEditRequestBulkEditChangeArtists';
export * from './BulkEditRequestBulkEditChangeArtistsArtistChangeInner';
export * from './BulkEditRequestBulkEditChangeArtistsArtistLinkInner';
export * from './BulkEditRequestBulkEditContributionsInner';
export * from './BulkEditRequestBulkEditCorrectInner';
export * from './BulkEditRequestBulkEditRecordingsInner';
export * from './BulkEditRequestBulkEditReleaseLink';
export * from './BulkEditResultResponse';
export * from './BulkEditResultResponseResultsInner';
export * from './BulkEditResultResponseResultsInnerError';
export * from './BulkEditResultResponseResultsInnerRejectedInner';
export * from './BulkLookupReleaseRequest';
export * from './BulkLookupReleaseResponse';
export * from './BulkLookupReleaseResponseRecordingsInner';
export * from './BulkManualChangesRequest';
export * from './BulkManualChangesResponse';
export * from './BulkManualChangesResponseRecordingsInner';
export * from './ChangeAssociatedArtistsRequest';
export * from './ChangeAssociatedArtistsRequestEditsInner';
export * from './ClientSocietyFormTask';
export * from './ClientUser';
export * from './ClientUserUserSettings';
export * from './Company';
export * from './CompanyCompanyInformation';
export * from './CompanyFormRole';
export * from './CompanyFormRoleFormsInner';
export * from './CompanyInformation';
export * from './CompanyInformationBankDetails';
export * from './CompanyInformationLogoImage';
export * from './CompanyRoleFormsInner';
export * from './ConfidenceStats';
export * from './ConfidenceStatsConfidenceCategoriesInner';
export * from './CorrectRecordingRequest';
export * from './CorrectRecordingRequestEditsInner';
export * from './CorrectRecordingRequestEditsInnerDupIsrcsInner';
export * from './CorrectReleaseRequest';
export * from './CorrectReleaseRequestEditsInner';
export * from './CreateArtistAndLinkRequest';
export * from './CreateArtistAndLinkRequestEditsInner';
export * from './CreatePandadocsSessionId';
export * from './CreateReleaseAndLinkRequest';
export * from './DailyPayment';
export * from './Debug';
export * from './DeleteDeclinedArtistRunStatus';
export * from './DiscogsArtist';
export * from './DiscogsArtistImagesInner';
export * from './DiscogsSearch';
export * from './DiscogsSearchArtistsInner';
export * from './DiscogsSearchArtistsInnerAliasesInner';
export * from './DiscogsSearchArtistsInnerExternalIdsInner';
export * from './EvidenceImageSignedUrl';
export * from './EvidenceImageSignedUrlRequest';
export * from './ExternalEvidenceImageSignedUrl';
export * from './ExternalEvidenceImageSignedUrlRequest';
export * from './FinancialYears';
export * from './IdentityDocumentTypes';
export * from './IdentityVerficationSubmission';
export * from './LinkAliasToBand';
export * from './LinkReleaseRequest';
export * from './ListSecondaryDiscographies';
export * from './LoginWithEmailorUsernameAuthToken';
export * from './LookupArtistsQuery';
export * from './LookupArtistsResponse';
export * from './LookupArtistsResponseArtistsInner';
export * from './LookupArtistsResponseArtistsInnerMembersInner';
export * from './LookupClientAliasesResponse';
export * from './LookupClientAliasesResponsePersonasInner';
export * from './LookupReleaseQuery';
export * from './LookupReleaseResponse';
export * from './LookupReleaseResponsePayload';
export * from './LookupSourceArtistResponse';
export * from './LookupSourceArtistResponseMembersInner';
export * from './ManageContributionsRequest';
export * from './ManageContributionsRequestEditsInner';
export * from './MembershipForms';
export * from './MembershipStatus';
export * from './OnboardingProgress';
export * from './OnboardingStep';
export * from './OnboardingSteps';
export * from './PPLReviewExport';
export * from './PandadocDocumentIds';
export * from './PandadocDocumentIdsDocumentsInner';
export * from './PandadocEgress';
export * from './Payment';
export * from './PipelineRunRequest';
export * from './PipelineRunStatus';
export * from './PreregisteredSocietyPost';
export * from './PreregisteredSocietyPostId';
export * from './PrimaryDiscography';
export * from './PrimaryDiscographyExport';
export * from './PrimaryDiscographyRecordingsInner';
export * from './PrimaryDiscographyRequest';
export * from './PrimaryDiscographyRequestFieldFiltersInner';
export * from './PrimaryDiscographyRequestSortFieldsInner';
export * from './Recording';
export * from './RecordingEarliestParentRelease';
export * from './RecordingEarliestParentReleaseEvidenceImagesInner';
export * from './RecordingEvidenceReleasesInner';
export * from './RecordingManualChangesResponse';
export * from './RecordingManualChangesResponseFields';
export * from './RecordingManualChangesResponseFieldsArtists';
export * from './RecordingManualChangesResponseFieldsArtistsItemsInner';
export * from './RecordingManualChangesResponseFieldsContributions';
export * from './RecordingManualChangesResponseFieldsContributionsItemsInner';
export * from './RecordingManualChangesResponseFieldsContributionsItemsInnerChanges';
export * from './RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategory';
export * from './RecordingManualChangesResponseFieldsRecordingTitle';
export * from './RecordingManualChangesResponseFieldsRecordingVersion';
export * from './RecordingManualChangesResponseFieldsRecordingVersionItemsInner';
export * from './RecordingParentRecording';
export * from './RecordingPerformance';
export * from './RecordingPersona';
export * from './RecordingPplContributionsInner';
export * from './RecordingThumbnailEvidenceImage';
export * from './RecordingWestburyContributionsInner';
export * from './ReleaseManualChangesResponse';
export * from './ReleaseManualChangesResponseFields';
export * from './Representative';
export * from './SearchForSource';
export * from './SecondaryDiscography';
export * from './ServiceResponse';
export * from './SignMembershipForms';
export * from './SigninAuthToken';
export * from './Signup';
export * from './SignupAuthToken';
export * from './SignupAuthTokenToken';
export * from './Society';
export * from './SocietyContactInformation';
export * from './SocietyForm';
export * from './SocietyFormRole';
export * from './SocietyFormRoleFormsInner';
export * from './SocietyLogins';
export * from './SocietyLoginsData';
export * from './SocietyPortalTasks';
export * from './SourceId';
export * from './StatementsJson';
export * from './StatementsJsonMetadata';
export * from './StatementsJsonPaymentsInner';
export * from './TaxFormRole';
export * from './TermsOfAgreement';
export * from './TermsOfAgreementConfirmation';
export * from './TermsOfAgreementConfirmationPandadocDocumentIdsInner';
export * from './TermsOfAgreementRepresentativeFee';
export * from './TermsOfAgreementSlidingScalesInner';
export * from './TermsOfAgreementSocietyCommissionRatesInner';
export * from './TokenBlacklist';
export * from './TokenObtainPair';
export * from './TokenRefresh';
export * from './TokenVerify';
export * from './UnlinkAliasFromBand';
export * from './UpdateSecondaryDiscography';
export * from './UploadMembershipForms';
export * from './UserSettings';
export * from './ValidateIsrcRequest';
export * from './ValidateIsrcResponse';
export * from './ValidateIsrcResponseMatchesInner';
